import { Action, createReducer, on } from '@ngrx/store';
import { decreaseLoading } from '../utils';
import * as RouterTypeActions from './router-types.actions';
import { RouterTypesState } from './router-types.models';

export let devicesInitialState: RouterTypesState = {
    loading: 0,
    routerTypes: [],
    initiallyLoaded: false,
};

export const routerTypeReducer = createReducer(
    devicesInitialState,
    on(RouterTypeActions.loading, (state) => {
        return { ...state, loading: state.loading + 1 };
    }),
    on(RouterTypeActions.loadingDone, (state) => {
        return { ...state, loading: decreaseLoading(state.loading) };
    }),
    on(RouterTypeActions.loadedRouterTypes, (state, { data }) => {
        return { ...state, routerTypes: data.entries ? data.entries : [], initiallyLoaded: true };
    })
);

export function routerTypes(state = devicesInitialState, action: Action): RouterTypesState {
    return routerTypeReducer(state, action);
}
